exports.ECarouselType = {
  PHOTO: "PHOTO",
  VIDEO: "VIDEO",
};
